// Where people reach us. The mailbox is set up with the domain's email forwarding (deploy/site.md).
export const CONTACT_EMAIL = "hello@opencloudsecurity.co.uk";
export const PRIVACY_EMAIL = "privacy@opencloudsecurity.co.uk";
